import React, {useEffect} from 'react'

import template from './hero-11.twig'

import parse from 'html-react-parser'

import hubspotForm from './../../scripts/hubspot-form.legacy'

import StickerPlayground from '../../scripts/stickers-playground.legacy'

import {
  ContentOptions,
  HeadlineOptions,
  HubspotForm,
  VideoOptions,
  Offset,
} from '@miro-site/components_utils'

export interface Hero11Props {
  offset?: Offset
  headline?: HeadlineOptions
  content?: ContentOptions
  form?: HubspotForm
  video?: VideoOptions
  children?: React.ReactNode
}

const Hero11 = (props: Hero11Props): React.ReactElement => {
  useEffect(() => {
    hubspotForm.init()

    const defaultStickers = [
      'https://static-website.miro.com/static/images/sticker-playground/stickers-1.svg',
      'https://static-website.miro.com/static/images/sticker-playground/stickers-2.svg',
      'https://static-website.miro.com/static/images/sticker-playground/stickers-3.svg',
      'https://static-website.miro.com/static/images/sticker-playground/stickers-4.svg',
      'https://static-website.miro.com/static/images/sticker-playground/stickers-5.svg',
      'https://static-website.miro.com/static/images/sticker-playground/stickers-6.svg',
      'https://static-website.miro.com/static/images/sticker-playground/stickers-7.svg',
      'https://static-website.miro.com/static/images/sticker-playground/stickers-8.svg',
      'https://static-website.miro.com/static/images/sticker-playground/stickers-9.svg',
      'https://static-website.miro.com/static/images/sticker-playground/stickers-10.svg',
      'https://static-website.miro.com/static/images/sticker-playground/stickers-11.svg',
      'https://static-website.miro.com/static/images/sticker-playground/stickers-12.svg',
      'https://static-website.miro.com/static/images/sticker-playground/stickers-13.svg',
      'https://static-website.miro.com/static/images/sticker-playground/stickers-14.svg',
      'https://static-website.miro.com/static/images/sticker-playground/stickers-15.svg',
      'https://static-website.miro.com/static/images/sticker-playground/stickers-16.svg',
    ]

    const containers = document.querySelectorAll('[data-sticker-playground="1"]')

    containers.forEach(container => {
      const playground = new StickerPlayground(defaultStickers, container, {
        ignoredElements: [
          container.querySelector('.com-el-hubspot-form__container'),
          container.querySelector('.com-sec-hero-11__video-wrapper'),
          container.querySelector('.com-sec-hero-11__logo'),
        ],
      })

      playground.init()
    })

    loadParallax()

    async function loadParallax() {
      const scene = document.getElementById('cursors')

      if (scene) {
        const Parallax = (await import('parallax-js')).default
        new Parallax(scene)
      }
    }
  }, [])

  return (
    <>
      {parse(
        template({
          ...props,
          component_name: 'Hero Section',
          ctf_assets: 'images.ctfassets.net',
        }),
      )}
    </>
  )
}

export default Hero11
